import React from 'react';
import *  as PropTypes from 'prop-types';

import {imageUrl} from 'helpers/ApplicationHelper';

const HowItWork = ({step:{img,num,desc,content,period,reverseMobile}}) => {
  return (
      <div className={'how-it-works-homepage step-preview' +
      (reverseMobile ? ' reverse' : '')}>
        <img className="step-img" src={imageUrl(`${img}`)} alt=""/>
        <div className="step-desc">
          <div className="num">{num}</div>
          <hr className='underline'/>
          <div className='desc' dangerouslySetInnerHTML={{__html: desc}}/>
          <div className='content' dangerouslySetInnerHTML={{__html: content}}/>
          <div className='period' dangerouslySetInnerHTML={{__html: period}}/>
        </div>
      </div>
  );
};

HowItWork.propTypes = {
  step:PropTypes.object
};

HowItWork.defaultProps = {
  step: {
    img: '',
    num: 0,
    desc: '',
    content: '',
    period: '',
    reverseMobile: '',
  },
};

export default HowItWork;